module.exports = __webpack_public_path__ + "img/w3_bookmark_solid_dark.ba1c351d.png";